import { ReactNode, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Alert, Button } from "@mui/material";
import { Link } from "react-router-dom";
import { RootState } from "../../redux/store";
import checkRoutePermissions, { portalHome } from "../../routes/appRoutePermissions";
import { setAppState } from "../../redux/features/appStateSlice";

type Props = {
  state?: string,
  children: ReactNode;
};

const PageWrapper = (props: Props) => {
  const dispatch = useDispatch();
  const auth = useSelector((state: RootState) => state.auth);

  useEffect(() => {
    if (props.state) {
      dispatch(setAppState(props.state));
    }
  }, [dispatch, props.state]);

  if (!checkRoutePermissions(auth, { state: props.state ?? "" })) {
    return (
      <Alert severity="warning" sx={{ m: 2 }} action={
        <Button component={Link} to={portalHome(auth)} color="inherit" size="small">
          Go to my home page
        </Button>
      }>
        You do not have permission to view this page.
      </Alert>
    );
  }
  return (
    <>{props.children}</>
  );
};

export default PageWrapper;
